import { iosCartBoldWeight } from 'features/cart/styles';
import { ICartEntry } from 'features/cart/types';
import { calculateEntryTotalPrice } from 'features/cart/utils';
import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl';

import { Skeleton } from 'components/ui/skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants';

import { CartEntryDeleteButton } from '../cart-actions/cart-entry-delete-button';
import { CartEntryDuplicateButton } from '../cart-actions/cart-entry-duplicate-button';
import { CartEntryEditButton } from '../cart-actions/cart-entry-edit-button';
import { CartEntryRewardActionButton } from '../cart-actions/cart-entry-reward-action-button';

export const CartEntryFooter = ({
  cartEntry,
  isLoading,
  showPriceSkeleton = false,
  quantityOnCart,
}: {
  cartEntry: ICartEntry;
  isLoading?: boolean;
  showPriceSkeleton?: boolean;
  quantityOnCart?: number;
}) => {
  const { formatCurrencyForLocale } = useUIContext();
  const entryTotalPrice = calculateEntryTotalPrice(cartEntry);
  const priceText = entryTotalPrice === 0 ? t('free') : formatCurrencyForLocale(entryTotalPrice);

  return (
    <View style={styles.footer}>
      <CartEntryDeleteButton cartEntry={cartEntry} disabled={isLoading} variant="iconOnly" />
      <CartEntryDuplicateButton
        cartEntry={cartEntry}
        disabled={isLoading}
        quantityOnCart={quantityOnCart}
      />
      <CartEntryEditButton cartEntry={cartEntry} disabled={isLoading} />

      <View style={{ flex: 1 }} />

      <CartEntryRewardActionButton cartEntry={cartEntry} isLoading={!!isLoading} />
      {showPriceSkeleton ? (
        <Skeleton shape="rectangle" style={styles.priceSkeleton} />
      ) : (
        <Typography style={styles.editText}>{priceText}</Typography>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
    alignItems: 'center',
    gap: 16,
  },
  editText: {
    fontSize: 14,
    fontFamily: primitive.fontFamily.$headers,
    ...iosCartBoldWeight,
    color: primitive.$bbqBrown,
  },
  priceSkeleton: {
    width: 42,
    height: 18,
    marginVertical: 0,
  },
});
